import * as actionTypes from '../actions/actionTypes';

export default function bankNameInfoReducer(state = [], action) {
  switch(action.type){
    case actionTypes.SET_BANKNAME_INFO: {
      return action.bankNameInfo;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/bankNameInfoReducer.js